export default __webpack_public_path__ + "static/media/img_shop-type02.fe4f67c3.png";